import { useRouter } from 'next/router';

import useMenuSidebarStyles from './MenuSidebarJSS';
import Navigation from '../Navigation/Navigation';

function MenuSidebar({ closeMenu }) {
  const classes = useMenuSidebarStyles();
  const router = useRouter();
  const asPath = router.asPath.replace(router.basePath, '');

  return (
    <div className={classes.root}>
      <div
        className={classes.overlay}
        onClick={closeMenu}
        role="presentation"
      />
      <div className={classes.menuContainer}>
        <span
          className={classes.closeIcon}
          onClick={closeMenu}
          role="button"
          tabIndex={0}
        >
          ×
        </span>
        <Navigation path={asPath} isMobileView />
      </div>
    </div>
  );
}

export default MenuSidebar;
